
import { ref, computed } from 'vue'
import { clickOutsideElement } from '../../foundation/js/clickoutside'

export default {
    name: "TheFooter",
    setup(){

        let toggleLanguageStatus = ref(false)
        
        const toggleLanguageSelect = () => {
            toggleLanguageStatus.value = !toggleLanguageStatus.value
            
            if (toggleLanguageStatus.value) {
                clickOutsideElement(closeLanguageSelect)()
            }
        }

        const closeLanguageSelect = () => {
            toggleLanguageStatus.value = false
        }

        const toggleStatusArrowPosition = computed(() => {
            return toggleLanguageStatus.value ? 'nlx-the-footer__language-selector-svg-container--rotated' : ''
        })
        

        return {
            toggleLanguageSelect, 
            toggleLanguageStatus,
            toggleStatusArrowPosition
        }
    }
}